import { useCallback } from 'react';
import { toast } from 'react-toastify';
import http from '@core/http';
import useAxios from '@hooks/useFetch';
import apiConfig from '@apiConfig';
import { components } from '@api/api';

export type ExportRequestData = components['schemas']['ByoMenuExampleExportFilter'];
export type ExportChartRequestData = components['schemas']['ByoFilterInput'];

interface ExportEndpoint {
    exportEndpoint: string;
    downloadEndpoint: string;
}

export default function useExport<TData>(config: ExportEndpoint) {

    const { doFetch } = useAxios<string>({
        method: 'post',
        url: apiConfig.get(config.exportEndpoint),
        lazy: true,
    });

    const executeExportAndDownload = useCallback(
        (requestData: TData) => {
            toast.info("Downloading...");

            doFetch({ data: requestData })
                .then((response) => {
                    const downloadToken = response?.data;
                    http.downloadFileXHRFromUrl(
                        'GET',
                        apiConfig.get(config.downloadEndpoint, { key: downloadToken })
                    )
                        .then(() => {
                            toast.success("Download was successful");
                        })
                        .catch(() => {
                            toast.error("Something went wrong");
                        });
                })
                .catch(() => {
                    toast.error("Something went wrong");
                });
        },
        [doFetch, config.downloadEndpoint]
    );

    return executeExportAndDownload;
}
